import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import axios from "axios";
import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';
import { API_BASE_URL, ENDPOINTS } from '../../config';
const notyf = new Notyf({
    position: {
        x: 'right',
        y: 'top'
    },
    ripple: true,
    dismissible: true,
});
const MicrosoftCallback = () => {
    const navigate = useNavigate();
    const [, setCookie] = useCookies(['token']);
    useEffect(() => {
        const handleMicrosoftCallback = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get("code");
                const error = urlParams.get("error");

                if (error) {
                    notyf.error("Microsoft login failed. Please try again.");
                    navigate("/login");
                    return;
                }

                if (!code) {
                    notyf.error("Invalid Microsoft login attempt.");
                    navigate("/login");
                    return;
                }

                //  Send code to your `/token` endpoint with provider=microsoft
                const response = await axios.post(
                    `${API_BASE_URL}${ENDPOINTS.AUTH.LOGIN}`,
                    {
                        oauth_data: {
                            provider: "microsoft",
                            code: code,
                        },
                    }
                );

                const { access_token } = response.data;

                if (!access_token) {
                    notyf.error("No token received from server.");
                    navigate("/login");
                    return;
                }

                // Store access_token securely
                setCookie(null, "token", access_token, {
                    path: "/",
                    secure: true,
                    sameSite: "strict",
                    maxAge: 60 * 60 * 24, // 1 day
                });

                // Fetch user chats
                const chatResponse = await axios.get(
                    `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
                    {
                        headers: { Authorization: `Bearer ${access_token}` },
                    }
                );

                if (!chatResponse.data[0]) {
                    // If no chat exists, create a new one
                    const newChat = await axios.post(
                        `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
                        {
                            title: "Ask Me Anything",
                            messages: [{ content: "", sender: "" }]
                        },
                        { headers: { Authorization: `Bearer ${access_token}` } }
                    );
                    navigate(`/c/${newChat.data.chat_id}`);
                } else {
                    navigate(`/c/${chatResponse.data[0].chat_id}`);
                }

                notyf.success("Microsoft login successful!");
            } catch (err) {
                console.error(err);
                notyf.error("Microsoft login error. Please try again.");
                navigate("/login");
            }
        };

        handleMicrosoftCallback();
    }, [navigate]);

    return <div>Logging you in via Microsoft...</div>;
};

export default MicrosoftCallback;
